// extracted by mini-css-extract-plugin
export default {"wrapper":"Overlay_wrapper__mJxxf","container":"Overlay_container__HJfUR"};